<div class="discreetProgressBar-step w-100" #step>
  <div class="discreetProgressBar-topLabel" *ngIf="_progress < 100">
    <!-- {{ time }} min -->
  </div>
  <div class="discreetProgressBar-topLabel" *ngIf="_progress >= 100">
    <!-- <img
      src="assets/images/valid.svg"
      alt="completed"
      style="margin-block: -10px"
    /> -->
  </div>
  <div
    class="discreetProgressBar-bar"
    style="height: 6px;"
  ></div>

  <div *ngIf="!activeStep" class="discreetProgressBar-bottomLabel">{{ text }}</div>
  <div *ngIf="activeStep" class="discreetProgressBar-bottomLabel activeStep">{{ text }}</div>
</div>
